export enum Currency {
  MXN = 'MXN',
  USD = 'USD',
  CLP = 'CLP',
}
